module.exports = __webpack_public_path__ + "img/CXR.2b6b1723.svg";